// --------------------------------------------------------
// Author: E.Pataky
// Date: 1/19/15
// desc: triangle model data to svg
// --------------------------------------------------------
"use strict";
var _ = require("underscore");
var cio_datamodel = require("cio-datamodel");
var toSVGutil = require("./toSVGutil");

var drawTriangleDataTo2D = function (svg, group, data, attrs) {
    console.assert(data instanceof cio_datamodel.TriangleData);
    var points = data.getPoints()
        .map(function(p) {
            return [p.x, p.y];
        });

    var attrs_total = {};
    _.extend(attrs_total, toSVGutil.styleToAttributes(data));
    if(attrs) _.extend(attrs_total, attrs);

    svg.polygon(group,
        points,
        attrs_total
    );
};

module.exports = drawTriangleDataTo2D;
